import { KeyValue } from '@app/core/components/KeyValue';
import { UserRole } from '@mi-front/core';
import { Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { UserWithGroup } from '../../../../../../core/types/users';
import { loginMethodIconMap } from '../../components/LoginMethodIconMap';
import { UserRoleInfo } from '../../components/UserRoleInfo';
import { loginMethodLabelMessages } from '../../messages';

interface Props {
  readonly user: UserWithGroup;
  readonly canEdit: boolean;
}

/**
 * Read-only user details: email, login method, name, role, and assigned group.
 */
export function UserInfo(p: Props) {
  const { user } = p;
  const { $t } = useIntl();

  return (
    <Box>
      <KeyValue
        label={$t({
          id: 'common.email',
          defaultMessage: 'Email',
        })}
      >
        {user.email}
      </KeyValue>
      {user.loginMethod && (
        <KeyValue
          label={$t({
            id: 'admin.users.loginMethod.label',
            defaultMessage: 'Método de login',
          })}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {loginMethodIconMap[user.loginMethod]} {$t(loginMethodLabelMessages[user.loginMethod])}
          </Box>
        </KeyValue>
      )}
      <KeyValue
        label={
          <FormattedMessage id="admin.users.viewScreen.fullName" defaultMessage="Nombre completo" />
        }
      >
        {user.name ? (
          `${user.name} ${user.surname}`
        ) : (
          <Box component="span" sx={{ color: 'text.secondary' }}>
            (<FormattedMessage id="common.text.notSet" defaultMessage="No establecido" />)
          </Box>
        )}
      </KeyValue>
      <KeyValue
        label={
          <FormattedMessage id="admin.users.viewScreen.userRole" defaultMessage="Rol de usuario" />
        }
      >
        <UserRoleInfo value={user.role} />
      </KeyValue>
      {user.role === UserRole.CLIENT_USER && (
        <KeyValue
          label={
            <FormattedMessage
              id="admin.users.viewScreen.assignedGroup.title"
              defaultMessage="Grupo asignado"
            />
          }
        >
          {user.group ? (
            user.group.name
          ) : (
            <Box component="span" sx={{ color: 'text.secondary' }}>
              <FormattedMessage
                id="admin.users.viewScreen.assignedGroup.noGroup"
                defaultMessage="- Sin grupo -"
              />
            </Box>
          )}
        </KeyValue>
      )}
    </Box>
  );
}
